import React from "react";
import { styled } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

const StyledDatePickerWrapper = styled("div")(() => ({
  margin: "2px 0px",
  backgroundColor: "white",
}));

const DatePickerWidget = ({
  label,
  value,
  onChange,
  disabled,
  minDate,
  maxDate,
}) => {
  const validValue = value ? dayjs(value, "DD-MM-YYYY", true) : null;

  const handleDateChange = (date) => {
    const formattedDate = date ? dayjs(date).format("DD-MM-YYYY") : null;
    onChange(formattedDate);
  };

  return (
    <StyledDatePickerWrapper>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <FormControl sx={{ width: "100%" }}>
          <InputLabel shrink sx={{ backgroundColor: "white", fontWeight: 400 }}>
            {label}
          </InputLabel>
          <DatePicker
            value={validValue && validValue.isValid() ? validValue : null}
            onChange={handleDateChange}
            disabled={disabled}
            minDate={minDate}
            maxDate={maxDate}
            slotProps={{
              textField: {
                fullWidth: true,
                size: "small",
                inputProps: { readOnly: true },
                sx: {
                  "& .MuiInputBase-input": {
                    padding: "12px 10px",
                  },
                },
              },
            }}
          />
        </FormControl>
      </LocalizationProvider>
    </StyledDatePickerWrapper>
  );
};

export default DatePickerWidget;
